import React from "react";
import { Form, FormCheckProps } from "react-bootstrap";

export function IndeterminateCheckbox({ indeterminate, ...rest }: { indeterminate?: boolean } & FormCheckProps) {
    const ref = React.useRef<HTMLInputElement>(null!);

    React.useEffect(() => {
        if (typeof indeterminate === "boolean") {
            ref.current.indeterminate = !rest.checked && indeterminate;
        }
    }, [ref, indeterminate]);

    return <Form.Check type="checkbox" ref={ref} {...rest} />;
}
